import { render, staticRenderFns } from "./ModalFilterBookmarks.vue?vue&type=template&id=67fff238&"
import script from "./ModalFilterBookmarks.vue?vue&type=script&lang=js&"
export * from "./ModalFilterBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./ModalFilterBookmarks.vue?vue&type=style&index=0&id=67fff238&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports